// Module
var code = "<form-editor *ngIf=\"advancedSearchDynamicInputsConfiguration\" #advancedSearchDynamicInputsEditor [configuration]=\"advancedSearchDynamicInputsConfiguration\" [fieldsPerRow]=\"fieldsPerRow\" (valueChangedAction)=\"emitValueChanged()\" (selectionClosedAction)=\"emitSelectionClosed()\"> </form-editor>";
// Exports
module.exports = code;